import React from 'react';

const LoadingSpinner = ({ 
  size = 'large', 
  message = 'Loading...', 
  showMessage = true,
  variant = 'primary'
}) => {
  const sizeClasses = {
    small: { container: 'w-8 h-8', svg: 32, stroke: 3, dot: 'w-1.5 h-1.5' },
    medium: { container: 'w-12 h-12', svg: 48, stroke: 4, dot: 'w-2 h-2' },
    large: { container: 'w-16 h-16', svg: 64, stroke: 5, dot: 'w-2.5 h-2.5' },
    xl: { container: 'w-20 h-20', svg: 80, stroke: 6, dot: 'w-3 h-3' }
  };

  const sizes = sizeClasses[size];

  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      {/* Modern Gradient Ring Spinner */}
      <div className="relative" style={{ width: sizes.container, height: sizes.container }}>
        {/* Outer pulsing ring */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 opacity-20 animate-ping"></div>
        
        {/* Rotating gradient ring using SVG */}
        <svg
          className="absolute inset-0 animate-spin"
          width={sizes.svg}
          height={sizes.svg}
          viewBox={`0 0 ${sizes.svg} ${sizes.svg}`}
        >
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="50%" stopColor="#8b5cf6" />
              <stop offset="100%" stopColor="#ec4899" />
            </linearGradient>
          </defs>
          <circle
            cx={sizes.svg / 2}
            cy={sizes.svg / 2}
            r={(sizes.svg - sizes.stroke) / 2}
            fill="none"
            stroke="url(#gradient)"
            strokeWidth={sizes.stroke}
            strokeDasharray={`${(sizes.svg - sizes.stroke) * Math.PI * 0.6}`}
            strokeDashoffset={`${(sizes.svg - sizes.stroke) * Math.PI * 0.3}`}
            strokeLinecap="round"
          />
        </svg>
        
        {/* Inner pulsing dot */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className={`rounded-full bg-gradient-to-r from-blue-600 to-purple-600 animate-pulse ${sizes.dot}`}>
          </div>
        </div>
      </div>

      {/* Loading message */}
      {showMessage && message && (
        <div className="text-center">
          <p className="text-gray-600 font-medium animate-pulse">{message}</p>
          {/* Animated dots */}
          <div className="flex items-center justify-center space-x-1.5 mt-2">
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>
            <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>
            <div className="w-2 h-2 bg-purple-600 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
